import { mxn } from "@/lib/whatsapp";
import { Quote } from "lucide-react";

export const TestimonialCard = ({ photo, name, restaurant, city, quote, savings }) => (
  <article className="rounded-3xl bg-white border border-orange-100 p-7 shadow-sm flex flex-col h-full" data-testid="testimonial-card">
    <Quote className="w-8 h-8 text-brand-orange/40" />
    <p className="mt-4 text-gray-700 leading-relaxed flex-1">"{quote}"</p>
    <div className="mt-6 flex items-center gap-3">
      {photo ? <img src={photo} alt={name} className="w-12 h-12 rounded-full object-cover" /> : <div className="w-12 h-12 rounded-full bg-brand-orange/15 grid place-items-center font-heading font-bold text-brand-orange">{name?.[0] || "?"}</div>}
      <div>
        <p className="font-semibold text-brand-carbon">{name}</p>
        <p className="text-sm text-gray-500">{restaurant} · {city}</p>
      </div>
    </div>
    {savings > 0 && <span className="mt-4 self-start text-xs font-bold bg-brand-green/10 text-brand-green px-3 py-1.5 rounded-full">Ahorro mensual estimado: {mxn(savings)}</span>}
  </article>
);

export default TestimonialCard;
